import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notificationKeys } from '@/services/queryKeys';
import { notificationService } from '@/services/notification.service';

export function useNotificationList(scope?: 'mine') {
  return useQuery({
    queryKey: [...notificationKeys.lists(), scope ?? 'all'],
    queryFn: () => notificationService.list(scope),
    refetchInterval: 60_000,
    retry: 0,
  });
}

export function useUnreadCount(scope?: 'mine', enabled = true) {
  return useQuery({
    queryKey: notificationKeys.unreadCount(scope),
    queryFn: () => notificationService.unreadCount(scope),
    enabled,
    refetchInterval: 60_000,
    retry: 0,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationService.markRead(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: notificationKeys.all }),
  });
}

export function useMarkAllRead(scope?: 'mine') {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => notificationService.markAllRead(scope),
    onSuccess: () => qc.invalidateQueries({ queryKey: notificationKeys.all }),
  });
}
